<template>
  <div class="ColorPicker">
    <VMenu
      v-model="ui.menuModel"
      :close-on-content-click="false"
      :close-on-click="false"
      class="color-picker"
    >
      <template #activator="{ on }">
        <VTextField
          :value="value"
          readonly
          :label="label"
          :loading="loading"
          :append-icon="appendIcon"
          :append-outer-icon="appendOuterIcon"
          hide-details
          style="cursor: pointer"
          @click:append="$emit('click:append')"
          @click:append-outer="$emit('click:append-outer')"
          v-on="on"
        >
          <template #prepend-inner>
            <VAvatar
              :color="value"
              size="24px"
              v-on="on"
            >
              <VProgressCircular
                v-if="loading"
                indeterminate
                size="24"
                width="5"
                color="#fff"
              />
            </VAvatar>
          </template>
          <template #append>
            <slot name="append" />
          </template>
        </VTextField>
      </template>
      <VCard>
        <VCardText>
          <VColorPicker
            v-model="ui.pickerModel"
            mode="hexa"
            flat
            hide-mode-switch
            :value="value"
          />
        </VCardText>
        <VCardActions>
          <VBtn
            block
            @click="emit()"
            v-text="buttonText"
          />
        </VCardActions>
      </VCard>
    </VMenu>
  </div>
</template>

<script>
export default {
  name: 'ColorPicker',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: { type: String, default: '#000000' },
    buttonText: { type: String, default: 'Выбрать цвет' },
    label: { type: String, default: 'Цвет' },
    loading: { type: Boolean, default: false },
    appendIcon: { type: String, default: undefined },
    appendOuterIcon: { type: String, default: undefined },
  },
  data() {
    return {
      ui: {
        menuModel: false,
        pickerModel: this.value,
      },
    }
  },
  methods: {
    emit() {
      this.ui.menuModel = false
      this.$emit('change', this.ui.pickerModel)
    },
  },
}
</script>

<style lang="sass" scoped>
  .v-card__text
    padding-bottom: 0
  .v-card__actions
    padding-top: 0
</style>
